import React from "react";
import SiteHeader from "../components/SiteHeader";
import { useDocumentMeta } from "../useDocumentMeta";
import "../styles/redirect.css";

/** Catch-all for unknown paths, so they no longer render an empty page. */
const NotFoundPage: React.FC = () => {
  useDocumentMeta({
    title: "Page not found — PABS",
    description: "The page you're looking for doesn't exist or has moved.",
    robots: "noindex,follow",
  });

  return (
    <>
      <SiteHeader />

      <main className="rdx" id="main">
        <div className="rdx__card">
          <img
            className="rdx__mark"
            src="/pabs-mark.png"
            alt="PABS"
            width={64}
            height={64}
          />
          <h1 className="t-h3">Page not found</h1>
          <p className="t-sm">
            The page you're looking for doesn't exist or has moved.
          </p>

          <div className="rdx__actions">
            <a className="btn btn--primary" href="/">
              Back to homepage
            </a>
            <a className="btn btn--ghost btn--sm" href="/faq">
              Browse the FAQ
            </a>
          </div>
        </div>
      </main>
    </>
  );
};

export default NotFoundPage;
